import { get, getUrl } from '@/lib/fetch';

export function presign(params = {}) {
  return get('/attachments/presigns', params);
}

export function uploadUrl() {
  return getUrl('/attachments/uploads');
}
